document.addEventListener("DOMContentLoaded", function () {
    const { id: productId, limit: thresholdLimit, isInsurance: isInsuranceEnabled } = window.free_product_config;
    const ADD_OPERATION = "add"
    const REMOVE_OPERATION = "remove"

    document.addEventListener("cart:change", (event) => {
        const cartDetails = event.detail.cart;
        const moneyRate = Shopify.currency.rate ? Number(Shopify.currency.rate) : 1

        const { items, original_total_price } = cartDetails;
        const hasReachedThreshold = Number(original_total_price) >= Number(thresholdLimit * moneyRate);
        const currentTypeOperation = hasReachedThreshold ? ADD_OPERATION : REMOVE_OPERATION;
        const isFreeProductInCart = [...items].some(item => item.id == productId);
        const isInsuranceEnabledBoolean = isInsuranceEnabled == "true" ? true : false;
        const shouldAddFreeProduct = !(currentTypeOperation === ADD_OPERATION && isFreeProductInCart);

        changeFreeProductToCart(prepareFreeProductData(productId, currentTypeOperation, shouldAddFreeProduct), shouldAddFreeProduct)
            .then(() => refreshCartIfRequired(!isInsuranceEnabledBoolean))
            .then(() => {
                if (isInsuranceEnabledBoolean) {
                    document.dispatchEvent(new CustomEvent('cart-custom:change', { bubbles: true, detail: { cart: cartDetails } }));
                }
            })
            .catch((error) => console.error(error));
    });

    function refreshCartIfRequired(shouldRefresh) {
        if (shouldRefresh) document.dispatchEvent(new CustomEvent("cart:refresh"));
    }

    function prepareFreeProductData(productId, type) {
        return { [productId]: type === ADD_OPERATION ? 1 : 0 };
    }

    function changeFreeProductToCart(updates, shouldAddProduct) {
        if (!shouldAddProduct) return delay(0)

        return fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ updates })
        }).catch((error) => {
            console.error('Error:', error);
        });
    }
    function delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
});